'use client'

import Image from 'next/image'
import {
  ABHA_HERO_SUCCESS_CREATE_ANOTHER_CARD_CTA,
  ABHA_HERO_SUCCESS_SHOW_BADGE,
  ABHA_HERO_WIDGET_SECONDARY_ARROW_ICON,
} from '@components/NewProduct/constants'
import { AbhaHeroCard } from '@components/NewProduct/AbhaHeroWidget/steps/AbhaHeroCard'
import { AbhaHeroSuccessBadge } from '@components/NewProduct/AbhaHeroWidget/steps/AbhaHeroSuccessBadge'
import { AbhaHeroSuccessActionButton } from '@components/NewProduct/AbhaHeroWidget/steps/AbhaHeroSuccessDownloadButton'
import type { AbhaSuccessCardVariant } from '@components/NewProduct/AbhaHeroWidget/steps/abhaSuccessTypes'
import type { AbhaCardPreviewData } from '@helpers/abhaWidgetHelper'

export type AbhaHeroSuccessLeftPanelProps = {
  cardVariant: AbhaSuccessCardVariant
  cardData: AbhaCardPreviewData
  badgeText?: string
  onDownloadAbhaCard?: () => void
  onCreateAnotherCard?: () => void
}

export const AbhaHeroSuccessLeftPanel = ({
  cardVariant,
  cardData,
  badgeText,
  onDownloadAbhaCard,
  onCreateAnotherCard,
}: AbhaHeroSuccessLeftPanelProps) => {
  const panelCardData: AbhaCardPreviewData = {
    ...cardData,
    relationshipLabel: undefined,
  }

  if (cardVariant === 'showAbhaNumber') {
    return (
      <div className="abha-hero-success__desktop-visual abha-hero-success__desktop-visual--show">
        <div className="abha-hero-success__show-stack">
          <AbhaHeroSuccessBadge label={badgeText ?? ABHA_HERO_SUCCESS_SHOW_BADGE} variant="onShowSurface" />

          <div className="abha-hero-success__show-panel">
            <AbhaHeroCard
              data={panelCardData}
              layout="resolve"
              variant="showAbhaNumber"
              animateReveal={false}
              className="abha-hero-success__card abha-hero-success__card--desktop-show"
              showDownloadAction
              onDownload={onDownloadAbhaCard}
            />
          </div>

          <AbhaHeroSuccessActionButton
            label={ABHA_HERO_SUCCESS_CREATE_ANOTHER_CARD_CTA}
            onClick={() => onCreateAnotherCard?.()}
            fullWidth
            trailingIcon={
              <Image
                src={ABHA_HERO_WIDGET_SECONDARY_ARROW_ICON}
                alt=""
                width={16}
                height={16}
                className="abha-hero-success__create-another-card-icon"
                aria-hidden
              />
            }
          />
        </div>
      </div>
    )
  }

  return (
    <div className="abha-hero-success__desktop-visual abha-hero-success__desktop-visual--hide">
      <div className="abha-hero-success__hide-card-stage">
        <AbhaHeroCard
          data={panelCardData}
          variant="hideAbhaNumber"
          className="abha-hero-success__card abha-hero-success__card--desktop-hide"
        />
      </div>
    </div>
  )
}
